import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";
const Main = lazy(() => import("../../components/settings/branchSetup/main"));

const BranchSetup = () => {
  return (
      <Suspense fallback={<CircularLoader />}>
        <Main />
      </Suspense>
  );
};

export default BranchSetup;
